class CrossSells extends HTMLElement {
  constructor() {
    super();

    this.atcButton = this.querySelector('button[name="cross-sells-atc"]');
    this.boundLayoutUpdate = this.updateLayout.bind(this);
  }

  connectedCallback() {
    if (!this.atcButton) return;

    this.atcButton.addEventListener('click', this.addToCart.bind(this));

    this.querySelectorAll(".cross-sells-secondary-list input[type='checkbox']").forEach((checkbox, index) => {
      checkbox.addEventListener('change', () => {
        this.querySelector(`.cross-sells-list-images-item:nth-child(${index + 1}) .cross-sells-list-images-item-inner`)?.classList.toggle('active', checkbox.checked);
        this.updateTotals();
      });
    });

    this.querySelectorAll('.cross-sells-secondary-list select').forEach((select, index) => {
      select.addEventListener('change', () => {
        this.handleVariantChange(select, index);
      });
    });

    this.updateLayout();
    window.addEventListener('resize', this.boundLayoutUpdate);
    window.addEventListener('orientationchange', this.boundLayoutUpdate);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.boundLayoutUpdate);
    window.removeEventListener('orientationchange', this.boundLayoutUpdate);
  }

  handleVariantChange(select, index) {
    const selectedOption = select.options[select.selectedIndex];
    const listItem = select.closest('.cross-sells-secondary-list-item');
    const checkbox = listItem?.querySelector("input[type='checkbox']");

    if (!selectedOption || !listItem || !checkbox) return;

    const productImage = this.querySelector(`.cross-sells-list-images-item:nth-child(${index + 1}) img`);

    if (productImage && selectedOption.dataset.variantImage) {
      productImage.src = selectedOption.dataset.variantImage;

      if (selectedOption.dataset.variantImageSrcset) {
        productImage.srcset = selectedOption.dataset.variantImageSrcset;
      }
    }

    checkbox.value = selectedOption.value;
    checkbox.dataset.comparePrice = selectedOption.dataset.variantComparePrice;
    checkbox.dataset.price = selectedOption.dataset.variantPrice;

    listItem.querySelector('[data-price-compare]').textContent = window.Shopify.formatMoney(selectedOption.dataset.variantComparePrice);
    listItem.querySelector('[data-price-sale]').textContent = window.Shopify.formatMoney(selectedOption.dataset.variantPrice);
    listItem.querySelector('[data-price-regular]').textContent = window.Shopify.formatMoney(selectedOption.dataset.variantPrice);
    listItem.querySelector('.product-card-price')?.setAttribute(
      'data-has-price-compare',
      Number(selectedOption.dataset.variantComparePrice) > Number(selectedOption.dataset.variantPrice) ? 'true' : 'false'
    );

    this.updateTotals();
  }

  updateTotals() {
    const checkedCheckboxes = this.getCheckedCheckboxes();

    const totalComparePrice = Array.from(checkedCheckboxes).reduce((sum, checkbox) => {
      return sum + Number(checkbox.dataset.comparePrice || 0);
    }, 0);

    let totalPrice = Array.from(checkedCheckboxes).reduce((sum, checkbox) => {
      return sum + Number(checkbox.dataset.price || 0);
    }, 0);

    const discount = Number(this.dataset.discount || 0);
    const discountMinItems = Number(this.dataset.discountMinItems || 0);

    if (discount > 0 && checkedCheckboxes.length >= discountMinItems) {
      totalPrice = ((100 - discount) / 100) * totalPrice;
    }

    const totalSavings = Math.max(totalComparePrice - totalPrice, 0);
    const totalDiscount = totalComparePrice > 0 ? Math.round((totalSavings / totalComparePrice) * 100) : 0;
    const totalComparePriceElement = this.querySelector('[data-total-compare-price]');
    const totalPriceElement = this.querySelector('[data-total-price]');
    const totalSavingsElement = this.querySelector('[data-total-savings]');
    const totalCompareWrapper = totalComparePriceElement?.closest('s');
    const totalSavingsWrapper = totalSavingsElement?.closest('.cross-sells-footer-savings');
    const discountAlert = this.querySelector('.cross-sells-footer-discount');

    if (totalComparePriceElement) totalComparePriceElement.textContent = window.Shopify.formatMoney(totalComparePrice);
    if (totalPriceElement) totalPriceElement.textContent = window.Shopify.formatMoney(totalPrice);
    if (totalSavingsElement) totalSavingsElement.textContent = `${window.Shopify.formatMoney(totalSavings)} (${totalDiscount}%)`;

    if (totalCompareWrapper) totalCompareWrapper.hidden = totalComparePrice <= totalPrice;
    if (totalSavingsWrapper) totalSavingsWrapper.hidden = totalComparePrice <= totalPrice;

    if (discountAlert) {
      discountAlert.classList.toggle('alert-success', checkedCheckboxes.length >= discountMinItems);
      discountAlert.classList.toggle('alert-warning', checkedCheckboxes.length < discountMinItems);
    }

    this.atcButton.disabled = checkedCheckboxes.length === 0;
  }

  getCheckedCheckboxes() {
    return this.querySelectorAll(".cross-sells-secondary-list input[type='checkbox']:checked");
  }

  updateLayout() {
    const footer = this.querySelector('.cross-sells-footer');
    const secondaryList = this.querySelector('.cross-sells-secondary-list');
    const imageList = this.querySelector('.cross-sells-list-images');

    if (!footer || !secondaryList || !imageList) return;

    if (window.matchMedia('(max-width: 1199px)').matches) {
      secondaryList.insertAdjacentElement('afterend', footer);
    } else {
      imageList.insertAdjacentElement('afterend', footer);
    }
  }

  async addToCart(event) {
    event.preventDefault();

    const selectedVariants = Array.from(this.getCheckedCheckboxes()).map((checkbox) => Number(checkbox.value)).filter(Boolean);

    if (!selectedVariants.length || !window.ThemeCart) return;

    this.atcButton.classList.add('loading');
    this.atcButton.disabled = true;
    this.atcButton.setAttribute('aria-busy', 'true');

    const items = selectedVariants.map((variantId) => ({
      id: variantId,
      quantity: 1
    }));

    try {
      await window.ThemeCart.add({ items }, { returnFocusTarget: this.atcButton });
    } finally {
      this.atcButton.classList.remove('loading');
      this.atcButton.disabled = false;
      this.atcButton.setAttribute('aria-busy', 'false');
    }
  }
}

customElements.define('cross-sells', CrossSells);
